(function() {
	'use strict';
	var
		slider = tns({
			"container": '#homepage-carousel',
			"items": 1,
			"mode": "gallery",
			"slideBy": "page",
			"speed": 1000,
			"autoplay": true,
			"swipeAngle": false,
			"mouseDrag": false,
			"nav": true,
			"controls": false,
			"controlsContainer": ".hp-carousel-controls",
			"controlsPosition": "bottom",
			"navContainer": ".hp-carousel-nav",
			"navPosition": "bottom",
			onInit: function(){
				disableHiddenButtons();
				$('.hp-carousel-controls').attr('tabindex', -1);
				$('.hp-carousel-controls [data-controls="prev"]').attr('tabindex', 0);
				$('.hp-carousel-controls [data-controls="next"]').attr('tabindex', 0);
				$('.hp-carousel-nav').attr('tabindex', -1);
				$('.hp-carousel-controls [data-nav]').attr('tabindex', 0);
			},
			"responsive": {
				992: {
					"controls": true
				}
			}
		});

	function disableHiddenButtons() {
		$('#homepage-carousel .tns-item').each(function(){
			$(this).find('.btn').attr('tabindex', -1);
			
			if ($(this).hasClass('tns-slide-active')) {
				$(this).find('.btn').attr('tabindex', 0);
			}
		});
	};

	// bind function to event
	slider.events.on('indexChanged', disableHiddenButtons);
})();
